import { BETA_BANNER_HEIGHT, BREADCRUMB_HEIGHT, PAGE_PADDING, TAB_LIST_HEIGHT } from '@components/bid_request/details/constants';

const getTitleHeight = () => {
  const title = document.querySelector('.request-details');

  if (!title) return 0;
  const marginBottom = 20;

  return title.getBoundingClientRect().height + marginBottom;
};

export const calculateStickyHeaderOffset = () => {
  const title = getTitleHeight();

  return PAGE_PADDING + BREADCRUMB_HEIGHT + title + BETA_BANNER_HEIGHT + TAB_LIST_HEIGHT;
};

export const isStickyHeaderVisible = () => (
  window.scrollY >= calculateStickyHeaderOffset()
);
